import moment from "moment";

export default {
  name: 'contract-details',
  components: {},
  props: ['respData'],
  data () {
    return {
      responseData:{},
      headers_Contacts:[
        {text:"Type", value:"type"},
        {text:"Name", value:"name"},
        {text:"Company Name", value:"companyName"},
      ],
      headers_LineItems:[
        {text:"Item Id", value:"itemId"},
        {text:"Product Id", value:"productId"},
        {text:"Stock Id", value:"stockId"},
        {text:"Serial Number", value:"serialNumber"},
        {text:"Name", value:"name"},
        {text:"Quantity", value:"quantity"},
        {text:"Has Fuel", value:"hasFuel"},
      ],
      headers_Notes:[
        {text:"Type", value:"type"},
        {text:"Value", value:"value"},
      ],
    }
  },
  computed: {

  },
  filters: {
    formatDates: function(value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      }
    },
  },
  mounted () {
this.responseData = this.respData;
  },
  methods: {

  }
}


